import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  close() {
    this.element.parentElement.removeAttribute("src");
    this.element.remove();
  }

  overlayClick(event) {
    if (event.target === this.element) {
      this.close();
    }
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.close();
    }
  }
}
